import React from "react";
import ProductSearchCard from "../ProductSearchCard/ProductSearchCard";
import { backend_url, currency } from "../../App";
import { Link } from "react-router-dom";

const slugify = (text) =>
  (text || "")
    .toLowerCase()
    .replace(/\s+/g, "-")
    .replace(/[^\w-]+/g, "")
    .replace(/--+/g, "-")
    .replace(/^-+|-+$/g, "");

const SearchResults = ({ results, setSearchResults }) => {
  return (
    <div className="p-4">
      <h2 className="text-lg text-purple-600 font-semibold mb-4">
        Search Results
      </h2>
      {results.length > 0 ? (
        <div className="grid grid-cols-2 sm:grid-cols-2 md:grid-cols-3 lg:grid-cols-4 gap-4">
          {results.map((product) => (
            <Link
              to={`/product/${product.id}/${slugify(product.name)}`}
              key={product.id}
              onClick={() => { setSearchResults([]); window.scrollTo(0, 0); }}
            >
              <div className="border p-3 shadow-lg rounded-lg hover:shadow-xl transition-all duration-200 h-full flex flex-col justify-between min-h-[350px]">
                <img crossOrigin="anonymous" 
                  src={product.images?.[0]}
                  alt={product.name}
                  className="w-full object-cover rounded-md mb-2 h-[220px] sm:h-[240px] md:h-[260px] lg:h-[280px]"
                />
                <div className="px-1 flex flex-col flex-grow">
                  <p className="mt-2 text-left font-semibold text-[#6e6e6e] text-sm sm:text-base line-clamp-2 h-[48px]">
                    {product.name}
                  </p>
                  <div className="text-sm font-semibold text-purple-600 mt-2">
                    {currency}
                    {product.old_price &&
                      Math.round(
                        (product.old_price * (100 - product.new_price)) / 100
                      )}
                  </div>
                  <div className="text-xs text-gray-500">
                    {product.old_price && (
                      <>
                        <span className="line-through">
                          ₹{product.old_price}
                        </span>
                        <span className="font-bold text-purple-600 ml-1">
                          ({product.new_price}% OFF)
                        </span>
                        &nbsp;
                        <span>
                          {product.scale === "Meters" ? "/meter" : "/piece"}
                        </span>
                      </>
                    )}
                  </div>
                </div>
              </div>
            </Link>
          ))}
        </div>
      ) : (
        <p className="text-gray-500">No results found.</p>
      )}
    </div>
  );
};

export default SearchResults;
